import { getTeamTypeName } from "@/helpers/teamHelpers"
import { Team } from "@/sources/kicker-amateur/types"
import Link from "next/link"

export default function TeamTag({href, team}:{href:string, team:Team}) {
  return <>
    <Link href={href} className="bg-gray-900 text-gray-50 rounded px-1.5 font-bold uppercase pb-px text-sm">
      {getTeamTypeName(team)}
    </Link>
  </>
}
